import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Card } from 'primeng/card';
import { Button } from 'primeng/button';
import { inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ProgressSpinner } from 'primeng/progressspinner';

@Component({
  selector: 'core-auth-login',
  standalone: true,
  imports: [CommonModule, Card, Button, ProgressSpinner],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  private readonly _route = inject(ActivatedRoute);
  private readonly _authService = inject(AuthService);
  showLogin = false;

  ngOnInit() {
    const queryParams = this._route.snapshot.queryParams;
    const issuer = queryParams['iss'];
    if (issuer) {
      this._authService.signIn('brightai');
    } else {
      this.showLogin = true;
    }
  }

  loginWithOkta() {
    const redirectTo =
      this._route.snapshot.queryParamMap.get('redirect') || '/dashboard';
    this._authService.signIn(redirectTo);
  }
}
